import { render, staticRenderFns } from "./StudentworkModal.vue?vue&type=template&id=17c08504&scoped=true&"
import script from "./StudentworkModal.vue?vue&type=script&lang=js&"
export * from "./StudentworkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c08504",
  null
  
)

export default component.exports